(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("clappr"));
	else if(typeof define === 'function' && define.amd)
		define(["clappr"], factory);
	else if(typeof exports === 'object')
		exports["FLVJSPlayback"] = factory(require("clappr"));
	else
		root["FLVJSPlayback"] = factory(root["Clappr"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_20__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition